import { themeFolderPath } from '../../App';
import React, { Component, type JSX } from 'react';
import { cart } from '../Cart/Cart';
import { price } from '../../util/price.function';

interface OverviewAddOnProps {
  id: string;
  idTraining: string;
  title: string;
  subject: string;
  level: string;
  price: string;
  tooltip?: string;
  inCart: boolean;
}

interface OverviewAddOnState {
  deleting: boolean;
  adding: boolean;
}

/**
 * Sub item in the cart, the inCart flag, determines
 * whether the sub-item is displayed as an upsell article
 * or as sub-item article.
 *
 * The course and level of an addon are extracted from
 * the parent training.
 */
export class OverviewAddOn extends Component<OverviewAddOnProps, OverviewAddOnState>{

  /**
  * set default state
  */
  public state: OverviewAddOnState = {
    deleting: false,
    adding: false,
  };

  /**
   * Remove the addOn from the php session. Show a loading
   * icon while deleting.
   */
  private onRemoveAddOn(): void {
    const { id, idTraining } = this.props;
    this.setState({ deleting: true });
    cart.removeArticle(idTraining, id);
  }

  /**
   * Render the addOn, the item has 2 possible state, "in the cart" or
   * "not yet added to the cart". The item is rendered accordingly.
   *
   * @inheritDoc
   */
  public render(): JSX.Element {
    const state: OverviewAddOnState = this.state;
    const props: OverviewAddOnProps = this.props;

    return (
      <li className="checkout__overview__item">
        <div className="checkout__overview__item-info">
          <div className="title">
            {props.title} | {props.subject} - {props.level}
          </div>
        </div>
        <div className="checkout__overview__item-price">
          <div className="delete">
            { state.deleting
              ? (<i className="fa fa-circle-o-notch fa-spin"/>)
              : (<img onClick={(): void => this.onRemoveAddOn()}
                src={ `${themeFolderPath}/images/checkout__cross.svg` }
                alt={'remove item'}/>)
            }
          </div>
          <div className="price">
            &euro; { price(props.price) }
          </div>
        </div>
      </li>
    );
  }
}
